import { createContext, type ReactNode, useState } from 'react';

import { type ArticleBlockType } from '@common/clients/api';

interface Props {
    children: ReactNode;
}

export enum BaseModalType {
    Accept = 'Accept',
    AndroidConfig = 'AndroidConfig',
    Config = 'Config',
    Confirmation = 'Confirmation',
    Create = 'Create',
    Default = 'Default',
    Duplicate = 'Duplicate',
    Edit = 'Edit',
    Iframe = 'Iframe',
    iOSConfig = 'iOSConfig',
}

type ModelState = {
    [key in BaseModalType | ArticleBlockType | string]?: { show: boolean };
};

interface State {
    state: ModelState;
    openModal?: (key: BaseModalType | ArticleBlockType | string) => void;
    closeModal?: (key: BaseModalType | ArticleBlockType | string) => void;
}

const ProviderState: ModelState = Object.values(BaseModalType).reduce(
    (state: ModelState, value: BaseModalType) => {
        state[value] = { show: false };
        return state;
    },
    {},
);

export const BaseModalContext = createContext<State>({ state: ProviderState });

export const BaseModalProvider = ({ children }: Props) => {
    const [state, setState] = useState<ModelState>(ProviderState);

    const openModal = (contextKey: BaseModalType | ArticleBlockType | string) =>
        setState((currentState) => ({ ...currentState, [contextKey]: { show: true } }));

    const closeModal = (contextKey: BaseModalType | ArticleBlockType | string) =>
        setState((currentState) => ({ ...currentState, [contextKey]: { show: false } }));

    return (
        <BaseModalContext.Provider value={{ state, openModal, closeModal }}>
            {children}
        </BaseModalContext.Provider>
    );
};
